import type { IBuild } from '@/entities/build.entity';
import { getActiveBuild, isActiveBuild } from '@/entities/build.entity';
import type { IBuildLogLine } from '@/entities/build-live.entity';
import { api } from './http';

export async function fetchMyBuilds() {
	const { data } = await api.get<{ builds: IBuild[] }>('/builds');
	return data.builds;
}

export async function cancelBuild(buildId: string) {
	const { data } = await api.post<{ build: IBuild }>(`/builds/${encodeURIComponent(buildId)}/cancel`);
	return data.build;
}

export async function installBuildApk(buildId: string) {
	await api.post(`/builds/${encodeURIComponent(buildId)}/install`);
}

export async function fetchBuildLogs(buildId: string) {
	const { data } = await api.get<{ buildId: string; lines: IBuildLogLine[]; failureMessage?: string }>(
		`/builds/${encodeURIComponent(buildId)}/logs`,
	);
	return data;
}

export { getActiveBuild, isActiveBuild };